import { Validator } from 'vee-validate'
import { webshopService } from '../services/WebshopService'

const checkEmailExist = async value => {
  try {
    let exists = await webshopService.checkEmail(value)
    if (!exists) return { valid: true }
    return { valid: false }
  } catch (e) {
    console.log(e)
    return { valid: true }
  }
}

Validator.extend('emailExists', {
  validate: checkEmailExist
}, {
  immediate: false
})
